import PropTypes from 'prop-types';
import TextCaption from './TextCaption';

const TextArea = (props) => {
  const {
    variant = 'primary',
    label = '',
    placeholder = 'Placeholder',
    status = '',
    name = '',
    className = '',
    message = '',
    disabled,
    value,
    onChange,
    onBlur,
  } = props;

  return (
    <>
      {label !== '' && (
        <label
          className={
            variant === 'primary'
              ? 'text-sm text-blue-hedgehog bold-text-2'
              : 'text-sm text-gray-davys bold-text-2'
          }
        >
          {label}
        </label>
      )}
      <div
        className={`${className} ${variant + '-text-field py-2 px-3'} ${
          status + '-text-field mb-2 mt-1 flex justify-between items-center'
        } ${disabled && 'cursor-not-allowed'}`}
      >
        <textarea
          placeholder={placeholder}
          className={`${
            variant + '-text-field'
          } border-none focus:outline-none bg-none w-full`}
          value={value}
          name={name}
          onChange={onChange}
          disabled={disabled}
          onBlur={onBlur}
        />
      </div>
      {status !== '' && <TextCaption status={status} message={message} />}
    </>
  );
};

TextArea.propTypes = {
  status: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  variant: PropTypes.string,
  message: PropTypes.string,
  value: PropTypes.string || PropTypes.number,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default TextArea;
